import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { MeetingTimeFilter } from "@upsquad/shared";

export const MeetingTypeFilter = {
	ONE_ON_ONE: "one_on_one",
	GROUP: "group",
} as const;
export type MeetingTypeFilter = (typeof MeetingTypeFilter)[keyof typeof MeetingTypeFilter];

interface MeetingState {
	activeTab: MeetingTypeFilter;
	timeFilter: MeetingTimeFilter;
	selectedDate: string | null;
}

const initialState: MeetingState = {
	activeTab: MeetingTypeFilter.ONE_ON_ONE,
	timeFilter: MeetingTimeFilter.UPCOMING,
	selectedDate: null,
};

export const meetingSlice = createSlice({
	name: "meeting",
	initialState,
	reducers: {
		setActiveTab(state, action: PayloadAction<MeetingTypeFilter>) {
			state.activeTab = action.payload;
		},
		setTimeFilter(state, action: PayloadAction<MeetingTimeFilter>) {
			state.timeFilter = action.payload;
		},
		setSelectedDate(state, action: PayloadAction<string | null>) {
			state.selectedDate = action.payload;
		},
	},
});

export const { setActiveTab, setTimeFilter, setSelectedDate } = meetingSlice.actions;
